import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridProProps } from '@mui/x-data-grid-pro/models/dataGridProProps';

import { useDataGridGroupStyling } from '~/components/SolaForceDataGrid/useDataGridGroupStyling';

export const SolaForceDataGrid = (props: DataGridProProps) => {
  const { sx, columns, columnGroupingModel, ...passThroughProps } = props;

  const processedProps = useDataGridGroupStyling({
    sx,
    columnGroupingModel,
    columns,
  });

  const dataGridProps = {
    ...processedProps,
    ...passThroughProps,
  };

  return <DataGridPro {...dataGridProps} />;
};
